import { Suspense, lazy } from 'react'
import { WorkspacePortalProvider } from '@/contexts/workspace-portal-context'

const JobWorkflowsPage = lazy(() => import('@/pages/jobs/workflows'))

export default function ProjectWorkflowsPage() {
  return (
    <WorkspacePortalProvider mode="project">
      <Suspense fallback={null}>
        <JobWorkflowsPage />
      </Suspense>
    </WorkspacePortalProvider>
  )
}
